import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils.ts'
import { NavigationItemBaseT, NavigationItemT } from '@/lib/types/navigationTypes.ts'
import NavigationGroupItemContent from '@/components/common/menu/NavigationGroupItemContent.tsx'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import somethingWrong from '@/lib/helpers/somethingWrong.ts'
import { useMenuStore } from '@/store/useMenuStore.ts'

export type NavigationItemLinkT = NavigationItemBaseT & {
  link: string
  issueTypeIri?: string
}

type PropsT = {
  item: NavigationItemT
  className?: string
}
export default function NavigationGroupItemLink({ item, className }: PropsT) {
  const setCurrIssueType = useProjectStageStore(state => state.setCurrIssueType)
  const closeMobileMenu = useMenuStore(state => state.closeMobileMenu)
  const openSecondaryMenu = useMenuStore(state => state.openSecondaryMenu)
  const mobileMenuState = useMenuStore(state => state.mobileMenuState)
  const path = useLocation()

  function handleClick() {
    // When tapping "Ustawienia" from the primary layer of the mobile menu,
    // drill into the secondary (settings) layer instead of closing the menu.
    // Previously this was gated on `!path.startsWith('/settings')`, which
    // broke this flow: user drills into settings, taps back to primary, taps
    // Ustawienia again → path is already /settings/*, so it falls through to
    // closeMobileMenu() and the menu disappears instead of drilling back in.
    // Keying off menu state instead of path makes it correct regardless of
    // where we currently are routing-wise.
    const enteringSettings =
      mobileMenuState === 'primaryMobile' && (item.link?.startsWith('/settings') ?? false)

    if (enteringSettings) {
      openSecondaryMenu()
    } else {
      closeMobileMenu()
    }

    const issueTypeIri = item.issueTypeIri
    if (issueTypeIri) {
      setCurrIssueType(issueTypeIri)
    }
  }
  if (!item.link) {
    somethingWrong()
    return <></>
  }

  // When navigating between settings pages, replace history so browser back
  // returns to the pre-settings view instead of walking through settings stack.
  const shouldReplace =
    path.pathname.startsWith('/settings') && item.link.startsWith('/settings')

  return (
    <li className={cn('flex w-full', className)}>
      <NavLink
        onClick={handleClick}
        to={item.link}
        replace={shouldReplace}
        end
        className={({ isActive }) => cn(`w-full rounded-md`, isActive && 'bg-accent')}
      >
        <NavigationGroupItemContent item={item} isQueue={item.link.includes('/sync-queue')} />
      </NavLink>
    </li>
  )
}
